import React from 'react'

import useDidMount from '@divvy-web/hooks.usedidmount'
import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage, useIntl } from '@divvy-web/i18n'
import TextLink from '@divvy-web/skylab.textlink'

import GoToDashboardButton from '@sputnik/components/GoToDashboardButton'
import MarketingContent, { MarketingQuote } from '@sputnik/components/MarketingContent'
import AfterSubmitInfoPageLayout from '@sputnik/pages/PostApplicationPages/AfterSubmitInfoPageLayout'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

const SubmissionError = () => {
  const [getClassName] = useNameFormatter('SubmissionError')
  const { formatMessage } = useIntl()
  const { track } = useWebTracking()

  useDidMount(() => {
    track('se_signup__application_submission_error__presented')
  })

  return (
    <AfterSubmitInfoPageLayout
      buttons={
        <>
          <GoToDashboardButton
            componentName={getClassName('')}
            onClick={() => {
              track('se_signup__application_submission_error_go_to_dashboard__fired')
            }}
          />
        </>
      }
      imageName='submission-error-page'
      infoContent={
        <FormattedMessage
          defaultMessage='It looks like there may have been an issue.'
          id='sputnik.SubmissionError__0wLquI'
        />
      }
      link={
        <TextLink
          className={getClassName('support-link')}
          href='https://help.bill.com/direct/s/?ref=marketing'
          target='_blank'
          onClick={() => {
            track('se_signup__application_submission_error_contact_support__fired')
          }}
        >
          <FormattedMessage
            defaultMessage='Contact support'
            id='sputnik.SubmissionError__5CI3KH'
          />
        </TextLink>
      }
      marketing={
        <MarketingContent
          image={{
            alt: formatMessage({
              defaultMessage: 'coworkers sitting next to each other at a table with laptops',
              id: 'sputnik.SubmissionError__4VFaNh',
            }),
            src: 'https://app.divvy.co/assets/stock-photos/credit-application-submission-error.png',
            isRounded: true,
          }}
          pillText={
            <FormattedMessage
              defaultMessage='Testimonial'
              id='sputnik.SubmissionError__MvBefC'
            />
          }
        >
          <MarketingQuote
            designation={
              <FormattedMessage
                defaultMessage='Controller, Murdock Martell'
                id='sputnik.SubmissionError__R7D/wB'
              />
            }
            name={
              <FormattedMessage
                defaultMessage='Marjorie Maas'
                id='sputnik.SubmissionError__SZFzOu'
              />
            }
            quote={
              <FormattedMessage
                defaultMessage='“Bill pay has allowed my clients to improve workflow, internal controls, and banking transactions. <strong>Overall, I see a 50% improvement in operational efficiency</strong>.”'
                id='sputnik.SubmissionError__8CfLdK'
                values={{
                  strong: (chunks) => <b>{chunks}</b>,
                }}
              />
            }
          />
        </MarketingContent>
      }
      title={
        <FormattedMessage
          defaultMessage='Whoops!'
          id='sputnik.SubmissionError__334LMo'
        />
      }
    />
  )
}

export default SubmissionError
